import { PlansFormMode } from './../../plans-form/plans-form.component';
import { Component, OnInit } from '@angular/core';
import { ModalRef } from '../../controls/modal/modal-ref';
import { FormGroup } from '@angular/forms';
import { ModalConfig } from '../../controls/modal/modal-config';
import { Plan } from 'src/app/model/Plan';

@Component({
    selector: 'app-plans-duplicate',
    templateUrl: './plans-duplicate.component.html',
    styleUrls: ['./plans-duplicate.component.css'],
    standalone: false
})
export class PlansDuplicateComponent implements OnInit {

  height: string = "150px;"
  mode: PlansFormMode = PlansFormMode.COPY;
  isSaving: boolean = false;
  formGroup: FormGroup = new FormGroup({});
  plan: Plan;

  constructor(private modalRef: ModalRef, public modalConfig: ModalConfig) { 
    this.plan = this.modalConfig.data.plan;
  }

  ngOnInit(): void {
  }

  updateForm(formGroup:FormGroup): void {
    this.formGroup = formGroup;
  }

  duplicatePlan(): void {
    this.plan.name = this.formGroup.get('nameCtrl').value;
    this.plan.description = this.formGroup.get('descriptionCtrl').value;
    this.plan.saveType = 'duplicate';
    this.modalRef.close({isPrimary: true, plan: this.plan});
  }

  cancel(): void {
    this.modalRef.close({isPrimary: false});
  }
}
